import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { OrderSideEnum } from '@modules/orders-module/enums/order-side.enum'
import { TranslatePipe } from '@ngx-translate/core'
import { OrderStatusEnum } from '@modules/orders-module/enums/order-status.enum'
import { HighlightDirective } from '@shared/directives/higlight.directive'
import { DatePipe, UpperCasePipe } from '@angular/common'
import { OrderTypeEnum } from '@modules/orders-module/enums/order-type.enum'
import { FilledOrderStatuses } from '@modules/orders-module/constants/filled-order-statuses'
import { CancelOrderStatuses } from '@modules/orders-module/constants/cancel-order-statuses'
import { ClipboardDirective } from '@shared/directives/clipboard/clipboard.directive'
import { TuiIcon } from '@taiga-ui/core'
import { TitleOrderTermPipe } from '@modules/orders-module/pipes/title-order-term.pipe'
import { OptionTypeEnum } from '@modules/options-module/general/enums/option-type.enum'
import { OptionOrderInterface } from '@modules/options-module/orders/interfaces/option-order.interface'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { PricePipe } from '@shared/pipes/price.pipe'
import { ProfitPipe } from '@shared/pipes/profit.pipe'
import { QuantityPipe } from '@shared/pipes/quantity.pipe'

@Component({
	selector: 'app-info-options-order-body',
	templateUrl: './info-options-order-body.component.html',
	styleUrl: './info-options-order-body.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslatePipe,
		HighlightDirective,
		ClipboardDirective,
		TuiIcon,
		TitleOrderTermPipe,
		DatePipe,
		UpperCasePipe,
		PricePipe,
		ProfitPipe,
		QuantityPipe,
	],
})
export class InfoOptionsOrderBodyComponent {
	protected readonly orderSideEnum: typeof OrderSideEnum = OrderSideEnum
	protected readonly orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum
	protected readonly optionTypeEnum: typeof OptionTypeEnum = OptionTypeEnum
	protected readonly filledOrderStatuses: OrderStatusEnum[] = FilledOrderStatuses
	protected readonly cancelOrderStatuses: OrderStatusEnum[] = CancelOrderStatuses

	@Input() order: OptionOrderInterface | null = null

	get isOrderFilled(): boolean {
		if (!this.order) return false

		return this.filledOrderStatuses.includes(this.order.status)
	}

	get isOrderCanceled(): boolean {
		if (!this.order) return false

		return this.cancelOrderStatuses.includes(this.order.status)
	}

	protected hasStatus(order: OrderInterface | null, statuses: OrderStatusEnum[]): boolean {
		if (!order) return false
		return statuses.includes(order.status)
	}
}
